import React from 'react';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Typography from '@mui/material/Typography';
import CircularProgress from '@mui/material/CircularProgress';
import Alert from '@mui/material/Alert';
import CronRow from './CronRow';

const HEADERS = [
  { label: 'Rotina', align: 'left' },
  { label: 'Agendamento', align: 'left' },
  { label: 'Última execução', align: 'left' },
  { label: 'Duração', align: 'left' },
  { label: 'Resultado', align: 'left' },
  { label: 'Erros/Avisos', align: 'left' },
  { label: 'Ações', align: 'right' },
];

// Prioridade de exibição: problemas primeiro, "sem registro" por último.
const STATUS_PRIORITY = { error: 0, stale_lock: 0, late: 1, running: 2, ok: 3, never: 4 };

/**
 * Ordena as rotinas por gravidade do status (erro/lock preso primeiro, sem registro por último).
 * @param {Array} routines
 * @returns {Array}
 */
function sortRoutines(routines) {
  return [...routines].sort((a, b) => {
    const diff = (STATUS_PRIORITY[a.status] ?? 5) - (STATUS_PRIORITY[b.status] ?? 5);
    if (diff !== 0) return diff;
    return (a.label || '').localeCompare(b.label || '');
  });
}

/**
 * CronsTable - Tabela de saúde das rotinas automáticas (Admin Geral > Rotinas)
 * @param {Object} props
 * @param {Array} props.routines
 * @param {boolean} props.isLoading
 * @param {string|null} props.error
 * @param {Function} props.onRunNow - recebe a rotina ao clicar em "Rodar agora"
 */
function CronsTable({ routines = [], isLoading = false, error = null, onRunNow }) {
  const sorted = sortRoutines(routines);

  return (
    <Paper
      sx={{
        borderRadius: '12px',
        boxShadow: '0 1px 4px rgba(0,0,0,0.06)',
        border: '1px solid #E8ECF0',
        overflow: 'hidden',
      }}
    >
      {error && (
        <Alert severity="error" sx={{ borderRadius: 0 }}>
          {error}
        </Alert>
      )}

      <TableContainer sx={{ boxShadow: 'none', borderRadius: 0 }}>
        <Table size="small">
          <TableHead>
            <TableRow sx={{ bgcolor: '#F8F9FC' }}>
              {HEADERS.map((h) => (
                <TableCell
                  key={h.label}
                  align={h.align}
                  sx={{ fontWeight: 600, color: 'text.secondary', fontSize: '0.8125rem', whiteSpace: 'nowrap' }}
                >
                  {h.label}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>

          <TableBody>
            {isLoading ? (
              <TableRow>
                <TableCell colSpan={HEADERS.length} align="center" sx={{ py: 6 }}>
                  <CircularProgress size={32} />
                </TableCell>
              </TableRow>
            ) : sorted.length === 0 ? (
              <TableRow>
                <TableCell colSpan={HEADERS.length} align="center" sx={{ py: 6 }}>
                  <Typography variant="body2" color="text.secondary">
                    Nenhuma rotina encontrada
                  </Typography>
                </TableCell>
              </TableRow>
            ) : (
              sorted.map((routine) => (
                <CronRow key={routine.script} routine={routine} onRunNow={onRunNow} />
              ))
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </Paper>
  );
}

export default CronsTable;
